import { useEffect, useState } from "react";
import axios from "axios";
import { Save } from "lucide-react";

const API = process.env.REACT_APP_BACKEND_URL;
const getHeaders = () => ({ Authorization: `Bearer ${localStorage.getItem("bct_token")}` });

export default function AdminSettings() {
  const [form, setForm] = useState({ id: "main", company_name: "", phone: "", email: "", address: "", working_hours: "" });
  const [loading, setLoading] = useState(false);
  const [saved, setSaved] = useState(false);

  useEffect(() => {
    axios.get(`${API}/api/settings`).then((r) => setForm(r.data));
  }, []);

  const handleSave = async () => {
    setLoading(true);
    try {
      await axios.put(`${API}/api/admin/settings`, form, { headers: getHeaders(), withCredentials: true });
      setSaved(true);
      setTimeout(() => setSaved(false), 3000);
    } catch { alert("Hata oluştu"); }
    finally { setLoading(false); }
  };

  return (
    <div data-testid="admin-settings">
      <h1 className="text-2xl font-bold text-white mb-6" style={{ fontFamily: "Outfit" }}>Site Ayarları</h1>

      <div className="bg-[#161923] border border-white/5 rounded-xl p-6 max-w-2xl space-y-5">
        <div>
          <label className="text-xs font-semibold text-slate-400 uppercase tracking-wider mb-2 block">Şirket Adı</label>
          <input type="text" value={form.company_name} onChange={(e) => setForm({ ...form, company_name: e.target.value })} className="admin-input" data-testid="settings-company" />
        </div>
        <div className="grid sm:grid-cols-2 gap-4">
          <div>
            <label className="text-xs font-semibold text-slate-400 uppercase tracking-wider mb-2 block">Telefon</label>
            <input type="text" value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} className="admin-input" data-testid="settings-phone" />
          </div>
          <div>
            <label className="text-xs font-semibold text-slate-400 uppercase tracking-wider mb-2 block">E-posta</label>
            <input type="text" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className="admin-input" data-testid="settings-email" />
          </div>
        </div>
        <div>
          <label className="text-xs font-semibold text-slate-400 uppercase tracking-wider mb-2 block">Adres</label>
          <textarea value={form.address} onChange={(e) => setForm({ ...form, address: e.target.value })} rows={2} className="admin-input resize-none" data-testid="settings-address" />
        </div>
        <div>
          <label className="text-xs font-semibold text-slate-400 uppercase tracking-wider mb-2 block">Çalışma Saatleri</label>
          <input type="text" value={form.working_hours} onChange={(e) => setForm({ ...form, working_hours: e.target.value })} className="admin-input" data-testid="settings-hours" />
        </div>

        <div className="flex items-center gap-3 pt-2">
          <button onClick={handleSave} disabled={loading} className="flex items-center gap-2 bg-[#FF5A00] hover:bg-[#e64f00] text-white px-5 py-2.5 rounded-xl text-sm font-semibold transition-colors disabled:opacity-50" data-testid="settings-save">
            <Save size={14} /> {loading ? "Kaydediliyor..." : "Kaydet"}
          </button>
          {saved && <span className="text-emerald-400 text-sm">Ayarlar kaydedildi!</span>}
        </div>
      </div>
    </div>
  );
}
